function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoostrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.411,
    y1: 0.0000436869,
    x2: 0.5927,
    y2: 0.0000436869,
    gradientTransform: "matrix(105.692328,-107.538486,107.538486,105.692328,-38.086266,69.00414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(2.745098%,0.392157%,20.784314%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(38.039216%,17.647059%,31.372549%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 7.621094 4.050781 L 22.378906 4.050781 C 24.324219 4.050781 25.902344 5.628906 25.902344 7.574219 L 25.902344 22.425781 C 25.902344 24.371094 24.324219 25.949219 22.378906 25.949219 L 7.621094 25.949219 C 5.675781 25.949219 4.097656 24.371094 4.097656 22.425781 L 4.097656 7.574219 C 4.097656 5.628906 5.667969 4.050781 7.621094 4.050781 Z M 7.621094 4.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.160156 13.476562 C 15.71875 13.476562 16.140625 13.355469 16.429688 13.109375 C 16.714844 12.871094 16.859375 12.507812 16.859375 12.035156 C 16.859375 11.566406 16.714844 11.214844 16.429688 10.972656 C 16.140625 10.726562 15.71875 10.601562 15.160156 10.601562 L 13.207031 10.601562 L 13.207031 13.476562 L 15.160156 13.476562 M 15.28125 19.410156 C 15.988281 19.410156 16.523438 19.261719 16.878906 18.964844 C 17.238281 18.671875 17.417969 18.222656 17.417969 17.621094 C 17.417969 17.035156 17.238281 16.597656 16.882812 16.300781 C 16.53125 16.007812 15.996094 15.855469 15.277344 15.855469 L 13.199219 15.855469 L 13.199219 19.410156 L 15.28125 19.410156 M 18.570312 14.53125 C 19.328125 14.75 19.914062 15.148438 20.332031 15.738281 C 20.75 16.324219 20.957031 17.046875 20.957031 17.898438 C 20.957031 19.207031 20.515625 20.183594 19.621094 20.824219 C 18.726562 21.46875 17.371094 21.792969 15.546875 21.792969 L 9.679688 21.792969 L 9.679688 8.226562 L 14.980469 8.226562 C 16.882812 8.226562 18.265625 8.507812 19.117188 9.078125 C 19.972656 9.648438 20.398438 10.5625 20.398438 11.8125 C 20.398438 12.472656 20.242188 13.039062 19.933594 13.507812 C 19.621094 13.96875 19.164062 14.3125 18.570312 14.53125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostrap);
export default __webpack_public_path__ + "static/media/boostrap.b7f02dffe23edb5d6970c8c7fbd270ae.svg";
export { ForwardRef as ReactComponent };